var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-button",class:_vm.social,attrs:{"data-action":_vm.dataAction,"data-fn-action":_vm.dataFnAction}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }